import React, {useState, useEffect} from 'react';
import InfoTooltip from './InfoTooltip';
import Card from '@material-ui/core/Card';
import '../../../scss/components/_signal_planning.scss';

const GlobalScenarioCard = props => {

    const [globalData, setGlobalData] = useState("");
    const [globalCount, setGlobalCount] = useState(0);

    useEffect(() => {
        setGlobalCount(0);
        if(props.scenariosList.length > 0 && props.capacityCat.length > 0) {
            gettingGlobalInfo();
        }
    }, [props.scenariosList, props.capacityCat])
    
    const gettingGlobalInfo = () => {
        props.scenariosList.forEach(function(rec, ind2) {
            if(rec['isGlobal'] && rec['period'] === props.period) {
                setGlobalCount( globalCount + 1 );
                let capacity = gettingCapacityRatio(rec);
                let cls = 'capacity-ratio red-txt';
                if(capacity) {
                    if(capacity.indexOf("Under") >= 0) {
                        cls = 'capacity-ratio emerald-txt';
                    } else if (capacity.indexOf("Near") >= 0) {
                        cls = 'capacity-ratio amber-txt';
                    }
                }
                let template = <div className='global-container'>
                    <div className={cls}>
                        <label className='indicator'></label>
                        <label>{capacity}</label>
                    </div>
                    <div className='global-scenario-summary'>
                        <div>
                            <label className='light-small-lbl'>Count date</label>
                            <label className='dark-small-lbl'>{props.handleFormatDate(rec['date_count'],'yr')}</label>
                        </div>
                        <div>
                            <label className='light-small-lbl'>Critical flow ratio</label>
                            <label className='dark-small-lbl'>{rec['critical_flow_ratio']}</label>
                        </div>
                    </div>
                </div>
                setGlobalData(template); 
            }
        });
    }

    const gettingCapacityRatio = (rec) => {
        let res = null;
        props.capacityCat.map(function(it, ind){
            if( (parseFloat(rec['critical_flow_ratio']) >= it['min'] && parseFloat(rec['critical_flow_ratio']) < it['max']) || (!it['max'] && parseFloat(rec['critical_flow_ratio']) >= it['min'])) {
                res = it['capacity'];
            }
        });
        return res;
    }
    
    return (
        <Card className='details-main-info details-date-time'>
            {
                globalCount === 0 ?
                <div className='global-container'>
                    <div className='capacity-ratio gray-txt'>
                        <label className='indicator'></label>
                        <label>{props.globalDefaultTitle}</label>
                    </div>
                    <label>{props.globalDefaultDesc}</label>
                </div>
                :
                    globalData === "" ?
                    <div className='global-container'>
                        <div className='capacity-ratio gray-txt'>
                            <label className='indicator'></label>
                            <label>No count data</label>
                        </div>
                        <label>{props.noCountDataTxt}</label>
                    </div>
                        : globalData
            }
        </Card>
    )

}

export default GlobalScenarioCard;